const state = {
  queueAdditionalData: false
};

const getters = {
  queueAdditionalData(state) {
    return state.queueAdditionalData;
  }
};

const mutations = {
  SET_QUEUE_ADDITIONAL_DATA(state, queueAdditionalData) {
    state.queueAdditionalData = queueAdditionalData;
  }
};

const actions = {
  setQueueAdditionalData({ commit }, queueAdditionalData) {
    commit("SET_QUEUE_ADDITIONAL_DATA", queueAdditionalData);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
